import React, { useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss';

function Timeline() {
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('reveal');
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.15, rootMargin: '0px 0px -50px 0px' }
        );

        const headers = document.querySelectorAll('#history .section-header');
        headers.forEach((header) => observer.observe(header));

        return () => observer.disconnect();
    }, []);

    return (
        <div className="container" id="history">
            <div className="timeline-container">
                <div className="section-header">
                    <span className="subtitle">Experience</span>
                    <h2>Career <span className="text-gradient">History</span></h2>
                    <div className="header-line"></div>
                </div>
                <VerticalTimeline className="vertical-timeline--two-columns">
                    <VerticalTimelineElement
                        className="vertical-timeline-element--work"
                        date="2020 - 2022"
                        icon={<FontAwesomeIcon icon={faBriefcase} />}
                    >
                        <h3>Technology Consultant</h3>
                        <h4>GPSLVN</h4>
                        <p>Full-stack Web Development, GenAI/LLM, Project Management, Business Development</p>
                    </VerticalTimelineElement>

                    <VerticalTimelineElement
                        className="vertical-timeline-element--work"
                        date="2022 - 2023"
                        icon={<FontAwesomeIcon icon={faBriefcase} />}
                    >
                        <h3>Full Stack Engineer</h3>
                        <h4>Smart Angle</h4>
                        <p>Frontend Development, Backend Development, User Experience, Team Leading</p>
                    </VerticalTimelineElement>

                    <VerticalTimelineElement
                        className="vertical-timeline-element--work"
                        date="2023 - 2025"
                        icon={<FontAwesomeIcon icon={faBriefcase} />}
                    >
                        <h3>Full Stack Engineer</h3>
                        <h4>Malamih</h4>
                        <p>Full-stack Development, API Development, User Experience</p>
                    </VerticalTimelineElement>

                    <VerticalTimelineElement
                        className="vertical-timeline-element--work"
                        date="2025 - Present"
                        icon={<FontAwesomeIcon icon={faBriefcase} />}
                    >
                        <h3>Data Analyst Intern & Full Stack Engineer</h3>
                        <h4>SEC</h4>
                        <p>Automation, Data Governance, Statistical Analysis, Full-stack Development, API Development</p>
                    </VerticalTimelineElement>
                </VerticalTimeline>
            </div>
        </div>
    );
}

export default Timeline;
